module.exports = __webpack_public_path__ + "static/media/th.86821b8c.svg";